var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.32349 6.28314C3.85337 4.59416 5.41852 3.44482 7.18866 3.44482H18.8128C20.583 3.44482 22.1482 4.59416 22.678 6.28314L23.5259 8.98569C23.9713 10.4053 23.5972 11.8381 22.723 12.8493V18.8383C22.723 21.0756 20.9093 22.8893 18.672 22.8893H7.32946C5.0922 22.8893 3.27854 21.0756 3.27854 18.8383V12.8493C2.40435 11.8381 2.03026 10.4053 2.47563 8.98569L3.32349 6.28314ZM11.0205 5.06519L10.4663 9.77681C10.2878 11.2939 11.4732 12.6269 13.0007 12.6269C14.5236 12.6269 15.7062 11.3023 15.537 9.79115L14.9809 5.06519H11.0205ZM17.1466 9.60566C17.146 9.5996 17.1452 9.59354 17.1446 9.58748L16.6126 5.06519H18.8128C19.8749 5.06519 20.8141 5.7548 21.132 6.76818L21.9799 9.47073C22.4707 11.0354 21.302 12.6269 19.6621 12.6269C18.4304 12.6269 17.3936 11.7049 17.2497 10.4817L17.1466 9.60566ZM9.38905 5.06519L8.75182 10.4817C8.6079 11.7049 7.57114 12.6269 6.33938 12.6269C4.69951 12.6269 3.53082 11.0354 4.0217 9.47073L4.86956 6.76818C5.18748 5.7548 6.12658 5.06519 7.18866 5.06519H9.38905Z",
    fill: "#FF7926"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreIcon);
export default __webpack_public_path__ + "static/media/store-icon.2fa45b09e57bc3081e8dc60112737ab4.svg";
export { ForwardRef as ReactComponent };